import { findParentNode } from 'prosemirror-utils'

export const findTable = (selection) =>
  findParentNode(
    (node) => node.type.spec.tableRole && node.type.spec.tableRole === 'table'
  )(selection)
